import React from 'react';
import styled from 'styled-components';
import {PriceBox} from '../../molecules/PriceBox/PriceBox';
import {MultipleItemsUnitPrice} from '../../molecules/UnitPrice/MultipleItemsUnitPrice';
import {ProductCardProps} from '../ProductCard/ProductCard';

type ProductCardItemPriceProps = Pick<
  ProductCardProps,
  | 'totalPrice'
  | 'unitPrice'
  | 'quantity'
  | 'lowestPriorPrice'
  | 'product'
  | 'overflowHiddenLPL30D'
>;

export const ProductCardItemPrice: React.FC<
  ProductCardItemPriceProps & {align?: 'left' | 'right'}
> = ({
  totalPrice,
  unitPrice,
  quantity,
  lowestPriorPrice,
  product,
  overflowHiddenLPL30D,
  align = 'right',
}) => {
  const isPriceV2 = 'finalPrice' in totalPrice;

  return (
    <>
      <ProductCardItemPriceWrapper>
        <PriceBox
          price={{...totalPrice, lpl30: lowestPriorPrice}}
          align={align}
          hideLpl30={!lowestPriorPrice && !isPriceV2}
          hideVat
          hideBadges
          productId={product.id + product.sizeLabel}
          overflowHiddenLPL30D={overflowHiddenLPL30D}
        />
        {!isPriceV2 && quantity.quantity > 1 && (
          <MultipleItemsUnitPrice unitPrice={unitPrice} />
        )}
      </ProductCardItemPriceWrapper>
    </>
  );
};

const ProductCardItemPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  white-space: nowrap;
`;
